/* Recently viewed products.
   - Capture: on a product page, store the current product (id, title, url,
     image, price, compare_at, timestamp) in localStorage.
   - Expiry: entries older than one week are dropped on every read.
   - Render: fill any <recently-viewed> section with cards from the store. */
(function () {
  if (window.__recentlyViewedInit) return;
  window.__recentlyViewedInit = true;

  var KEY = 'recently-viewed';
  var MAX = 12;
  var WEEK_MS = 7 * 24 * 60 * 60 * 1000;

  function read() {
    var now = Date.now();
    var list;
    try {
      list = JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
    if (!Array.isArray(list)) return [];
    // Drop anything older than a week.
    var fresh = list.filter(function (p) {
      return p && p.ts && now - p.ts < WEEK_MS;
    });
    if (fresh.length !== list.length) write(fresh);
    return fresh;
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* storage full or unavailable — ignore */
    }
  }

  function capture() {
    var el = document.querySelector('[data-recently-viewed-current]');
    if (!el) return;
    var data;
    try {
      data = JSON.parse(el.textContent);
    } catch (e) {
      return;
    }
    if (!data || !data.id) return;
    var list = read().filter(function (p) {
      return p.id !== data.id;
    });
    data.ts = Date.now();
    list.unshift(data);
    if (list.length > MAX) list = list.slice(0, MAX);
    write(list);
  }

  function esc(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : value;
    return div.innerHTML;
  }

  function cardHtml(p) {
    var media = p.image
      ? '<img class="recently-viewed__image" src="' + esc(p.image) + '" alt="" loading="lazy">'
      : '<span class="recently-viewed__image recently-viewed__image--empty"></span>';
    var price = p.compare_at
      ? '<span class="recently-viewed__price recently-viewed__price--sale">' +
        '<s>' + esc(p.compare_at) + '</s> ' + esc(p.price) + '</span>'
      : '<span class="recently-viewed__price">' + esc(p.price) + '</span>';
    return (
      '<a class="recently-viewed__card" href="' + esc(p.url) + '">' +
      '<div class="recently-viewed__media">' + media + '</div>' +
      '<div class="recently-viewed__title">' + esc(p.title) + '</div>' +
      price +
      '</a>'
    );
  }

  function render() {
    var sections = document.querySelectorAll('recently-viewed');
    if (!sections.length) return;
    var list = read();
    sections.forEach(function (section) {
      var currentId = parseInt(section.dataset.currentId, 10) || 0;
      var limit = parseInt(section.dataset.limit, 10) || 8;
      var grid = section.querySelector('[data-recently-viewed-grid]');
      if (!grid) return;
      var items = list
        .filter(function (p) {
          return p.id !== currentId;
        })
        .slice(0, limit);
      if (!items.length) {
        section.hidden = true;
        return;
      }
      grid.innerHTML = items.map(cardHtml).join('');
      section.hidden = false;
    });
  }

  function init() {
    capture();
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
